document.querySelectorAll('[data-tabs]').forEach(function(container) {
    preventScrollingOnClick();

    var firstTabHash = '#' + container.querySelector('[data-tab]').getAttribute('id');
    var activeTabHash = isValidTab(location.hash) ? location.hash : firstTabHash;
    setActiveTab(activeTabHash);

    window.addEventListener('hashchange', function() {
        setActiveTab(location.hash);
    });

    function preventScrollingOnClick() {
        container.querySelectorAll('[data-tab-link]').forEach(function(link) {
            link.addEventListener('click', function(event) {
                setActiveTab(link.getAttribute('href'));
                event.preventDefault();
            });
        });
    }

    function isValidTab(tabHash) {
        return tabHash && container.querySelector('[data-tab]' + tabHash) !== null;
    }

    function setActiveTab(tabHash) {
        if (!isValidTab(tabHash)) {
            return;
        }

        var links = container.querySelectorAll('[data-tab-link]');
        links.forEach(function(link) {
            link.classList.remove('active');
        });

        var tabs = container.querySelectorAll('[data-tab]');
        tabs.forEach(function(tab) {
            tab.classList.remove('active');
        });

        var activeTab = container.querySelector('[data-tab]' + tabHash);
        activeTab.classList.add('active');

        var activeLink = container.querySelector('[data-tab-link][href="' + tabHash + '"]');
        activeLink.classList.add('active');
    }
});


document.querySelectorAll('[data-content-from]').forEach(function(target) {
    var identifier = target.getAttribute('data-content-from');
    var source = document.querySelector('[data-content="' + identifier + '"]');
    target.appendChild(source);
});
